<div class="add-to-batches-table">
  <pdq-paginated-batch-table
    [state]="batchesState()"
    [totalCount]="totalCount()"
    [title]="'Fulfillment ready'"
    [columns]="columns"
    [carrierOptions]="carrierOptions"
    [locationOptions]="locations()"
    [ownerOptions]="owners"
    [showFilters]="true"
    [showPagination]="true"
    [countLoading]="countLoading"
    (onLoadPage)="onLoadPage($event)"
    (onFilterChange)="setFilters($event)"
    (onPageSizeChange)="initPageSize($event)"
    (onAddToBatch)="selectBatch($event)">
  </pdq-paginated-batch-table>
</div>
